import { SearchBrandModalHandler } from "./search-brand-modal-handler";
import { SearchBrandModalListener } from "./search-brand-modal-listener";
import { searchBrandModalForm } from "./search-brand-modal-form";

let singleton: SearchBrandModalHandler | null = null;

export class SearchBrandModalSetup {
    public static init(rootEl: Document | HTMLElement = document): SearchBrandModalHandler | null {
        if (singleton) return singleton;

        const overlayEl = searchBrandModalForm.getOverlay(rootEl);
        const modalEl = searchBrandModalForm.getModal(rootEl);
        const closeBtnEl = searchBrandModalForm.getCloseButton(rootEl);
        const filterInputEl = searchBrandModalForm.getFilterInput(rootEl);
        const showAllToggleEl = searchBrandModalForm.getShowAllToggle(rootEl);
        const popularRootEl = searchBrandModalForm.getPopularRoot(rootEl);
        const allRootEl = searchBrandModalForm.getAllRoot(rootEl);

        if (
            !(overlayEl instanceof HTMLElement) ||
            !(modalEl instanceof HTMLElement) ||
            !(popularRootEl instanceof HTMLElement) ||
            !(allRootEl instanceof HTMLElement)
        ) {
            return null;
        }

        singleton = new SearchBrandModalHandler({
            overlayEl,
            modalEl,
            popularRootEl,
            allRootEl,
            filterInputEl,
            showAllToggleEl,
        });

        SearchBrandModalListener.setup({
            rootEl,
            overlayEl,
            modalEl,
            closeBtnEl,
            popularRootEl,
            allRootEl,
            filterInputEl,
            handler: singleton,
        });

        return singleton;
    }
}
